import { motion } from "framer-motion";
import { Target, Lightning, ChartLineUp } from "@phosphor-icons/react";
import { useLang } from "@/lib/LangContext";

export const About = () => {
  const { t } = useLang();
  const values = [
    { icon: Target, ...t.about.value_1 },
    { icon: Lightning, ...t.about.value_2 },
    { icon: ChartLineUp, ...t.about.value_3 },
  ];
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 lg:py-32 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <p className="font-mono-x text-xs tracking-[0.3em] text-brand-500 font-bold">
              {t.about.overline}
            </p>
            <h2 className="mt-4 font-display font-medium tracking-tighter text-white text-4xl sm:text-5xl">
              {t.about.title}
            </h2>
            <p className="mt-6 font-mono-x text-sm sm:text-base text-slate-300 leading-relaxed">
              {t.about.description}
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {values.map((v, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-black p-8"
                data-testid={`about-value-${i}`}
              >
                <v.icon size={22} className="text-brand-500" />
                <h3 className="mt-6 font-display text-xl text-white tracking-tight">
                  {v.title}
                </h3>
                <p className="mt-3 font-mono-x text-xs text-slate-300 leading-relaxed">
                  {v.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
